import { HisItemParameter } from "../../his/behavior";
import { EditPhaseKinds } from "../../document";

export class HisInformationRollbackValueMaster {
  static shouldRollbackValue(hisItemParameter: HisItemParameter, progress: EditPhaseKinds, shouldUpdateAndRollbackCreateDate: boolean): boolean {
    if (shouldUpdateAndRollbackCreateDate) {
      if (progress === EditPhaseKinds.TemporarySave && (hisItemParameter.key === "CREATE_DATE")) {
        return true;
      }
    }
    return progress === EditPhaseKinds.TemporarySave &&
      (hisItemParameter.key === "LAST_UPDATE_USER" || hisItemParameter.key === "LAST_UPDATE_DATE");
  }
}
